import React from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import CardList from "./CardList";

interface CardInfo {
  id: number;
  enabled?: boolean;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fieldElement?: any;
}

interface Props {
  cards: ReadonlyArray<CardInfo>;
  setCards: (cards: ReadonlyArray<CardInfo>) => void;
  WrappedComponent?: React.ComponentType;
  removeCardEnabled?: boolean;
  toggleAlignment?: boolean;
  disableAllFields?: boolean;
}

const SortableList: React.FC<Props> = (props: Props): JSX.Element => {
  return (
    <DndProvider backend={HTML5Backend}>
      <CardList {...props} />
    </DndProvider>
  );
};

export default SortableList;
